<script lang="ts">
	import { page } from '$app/state';
	import Logo from '$assets/logos/vm-logo-bib-michelin.svg';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { langData } from '$lib/components/footer/constants';
	import LocaleModal from '$lib/components/footer/LocaleModal.svelte';
	import * as m from '$paraglide/messages';

	let isModaleOpen = $state(false);

	import Link from '$lib/components/atoms/link/Link.svelte';
	import {
		isLocaleAuthorizedToShowRegistrations,
		mapNewsletterRegistrationLinksByLocale,
	} from '$lib/components/footer/newsletterRegistrationLinks';
	import PolandRedirectedModal from '$lib/components/footer/PolandRedirectedModal.svelte';
	import { formatMagazineUrlWithTracking, magazineMediumMap, trackMagazineRedirection } from '$lib/services/tracking/googleAnalytics/magazine';

	interface Props {
		class?: string;
	}

	const { class: classnames = '' }: Props = $props();

	const locale = $derived(page.data?.locale ?? 'en-US');
</script>

<div class="flex flex-col gap-4 {classnames}">
	<div class="flex justify-between">
		<img src={Logo} alt="Michelin" height="24" width="120" />
		<Button
			text={langData[locale].text}
			icon={langData[locale].icon}
			variant="outline"
			onclick={() => (isModaleOpen = true)}
		/>
	</div>
	<div class="flex flex-col md:flex-row md:flex-wrap gap-4">
		{#if isLocaleAuthorizedToShowRegistrations(locale)}
			<Link
				href={mapNewsletterRegistrationLinksByLocale[locale]}
				icon="mail"
				button="filled"
				target="_blank"
				label={m.footer__newsletter_button()}
			/>
		{/if}
		<Link
			button="filled"
			label={m.footer__magazine_button()}
			icon="menu-book"
			color="light"
			href={formatMagazineUrlWithTracking(magazineMediumMap.browseButton, locale)}
			target="_blank"
			rel="external"
			onclick={() => {
				trackMagazineRedirection(magazineMediumMap.browseButton);
			}}
		/>
	</div>
</div>
{#if isModaleOpen}
	<LocaleModal bind:open={isModaleOpen} currentLocale={locale} />
{/if}

{#if page.data.locale === 'en-US' && page.url.searchParams.get('showModal') === 'poland'}
	<PolandRedirectedModal open={true} onShowLocaleModal={() => { isModaleOpen = true; }} />'
{/if}
